export default "__VITE_ASSET__d721c7ad__"